import { DropdownContainer, DropdownOption, DropdownPosition, IconDownload } from "@swivl-mono/ui";
import React, { useState } from "react";

import { downloadFile } from "../../utils/downloadFile";

interface RecordingDownloadDropdownButtonProps {
  audioSrc?: string;
  isDisabled: boolean;
}

export const RecordingDownloadDropdownButton: React.FC<RecordingDownloadDropdownButtonProps> = ({ audioSrc, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDownloadAudio = async () => {
    if (isDisabled || !audioSrc) {
      return;
    }

    await downloadFile(audioSrc);
  };

  const handleDownloadTranscript = () => {
    if (isDisabled) {
      return;
    }

    // TODO: implement transcript download when transcript URL or handler is available.
  };

  return (
    <DropdownContainer
      isOpen={isOpen}
      onOpenChange={(value) => (isDisabled ? null : setIsOpen(value))}
      position={DropdownPosition.RIGHT}
      trigger={
        <button
          type="button"
          disabled={isDisabled}
          className={`flex items-center transition-colors ${isDisabled ? "cursor-not-allowed text-grey-400" : "cursor-pointer text-grey-900 hover:text-orange-500"}`}
          aria-label="Download options"
          title="Download"
        >
          <IconDownload className="h-4 w-4" />
        </button>
      }
    >
      <DropdownOption disabled={isDisabled} onSelect={handleDownloadAudio} option={{ label: "Download Audio", value: "audio" }} />

      <DropdownOption disabled={true} onSelect={handleDownloadTranscript} option={{ label: "Download Transcript", value: "transcript" }} />
    </DropdownContainer>
  );
};
